import { Trans } from "@lingui/macro";
import { UiBox, UiSwitch } from "@smp/ui";
import { textCurrencySymbolGet } from "@smp/utils";
import { FC, useMemo } from "react";
import { useUpdateEffect } from "react-use";

import { useEpBillingAccount } from "@/hooks/use_ep_billing_account";

import { IInvoiceFormValues } from "../../use_invoice_form";

export interface IInternalAccountProps {
  paymentType: IInvoiceFormValues["paymentType"];
  product: IInvoiceFormValues["product"];
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const InternalAccount: FC<IInternalAccountProps> = ({
  paymentType,
  product,
  checked,
  onChange,
}) => {
  const { accountList } = useEpBillingAccount();

  const account = useMemo(
    () =>
      accountList?.find((account) => account.commodity === product.currency),
    [accountList, product.currency],
  );

  const isInternalAccountAvailable = useMemo(
    () => paymentType === "single" && !!account && account.balance > 0,
    [account, paymentType],
  );

  useUpdateEffect(() => {
    if (!isInternalAccountAvailable) {
      onChange(false);
    }
  }, [isInternalAccountAvailable]);

  if (!account || !isInternalAccountAvailable) {
    return null;
  }

  return (
    <UiBox mt={2}>
      <UiSwitch
        label={
          <Trans>
            Use internal funds ({account.balance}{" "}
            {textCurrencySymbolGet(account.commodity)} available)
          </Trans>
        }
        value={checked}
        onChange={(_e, checked) => onChange(checked)}
      />
    </UiBox>
  );
};
